import { useEmailThemeStore } from "../../../Design/useEmailThemeStore";

export const defaultStyles = {
  color:
    useEmailThemeStore.getState().defaultThemeVariables.p1[
      "theme-email-p1-color-text"
    ],
  fontWeight:
    useEmailThemeStore.getState().defaultThemeVariables.p1[
      "theme-email-p1-font-weight"
    ],
  fontSize:
    useEmailThemeStore.getState().defaultThemeVariables.p1[
      "theme-email-p1-font-size"
    ],
  lineHeight:
    useEmailThemeStore.getState().defaultThemeVariables.p1[
      "theme-email-p1-line-height"
    ],
  letterSpacing:
    useEmailThemeStore.getState().defaultThemeVariables.p1[
      "theme-email-p1-letter-spacing"
    ],
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
